import { FunctionComponent } from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import Grid from '@mui/material/Grid2';


export class HalfBorderedGridProps {
  children: any[];
  sx?: any;
  itemsPerRow?: number;
}

const HalfBorderedGrid: FunctionComponent<HalfBorderedGridProps> = ({children, sx, itemsPerRow: itemsPerRowProp}) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));

  let itemsPerRow = itemsPerRowProp ?? (isXs ? 2 : 3);
  const gridSize = Math.floor(12 / itemsPerRow) as any;

  return (
    <Box sx={{ flexGrow: 1, ...sx }}>
      <Grid container
        sx={{
          '--Grid-borderWidth': '1px',
          borderColor: 'divider',
        }}
      >
        {children.map((child, index) => {
          const isLastInRow = (index + 1) % itemsPerRow === 0;
          return (
            <Grid
              key={index}
              size={gridSize}
              minHeight={100}
              alignItems="center"
              sx={{
                textAlign: "center",
                pt: 1,
                borderTop: 'var(--Grid-borderWidth) solid',
                borderBottom: 'var(--Grid-borderWidth) solid',
                borderRight: isLastInRow ? 'none' : 'var(--Grid-borderWidth) solid',
                borderColor: 'divider',
              }}
            >
              {child}
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}

export default HalfBorderedGrid;